import React from 'react';
import './template-view.css';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import SwitchEditComponent from '../../components/SwitchEdit'
import Select from '../../components/SelectComponent'

class HomeView extends React.Component {

  state = {
    template: {},
    compiled: '',
    obj: `{
      client: {
        name: 'Company Name'
      }
    }`
  }

  setObj = (value) => {
    this.setState({
      obj: value
    });
  }
  handleChange = (prop, value) => {
    var t = this.state.template;

    t[prop] = value;
    this.setState({
      template: t,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id == 'new') this.props.setTemplate({});
    else this.props.getTemplate(this.props.match.params.id);
  }

  componentWillUpdate(props, state) {
    if (this.props.template) {
      if (state.template._id != props.template._id) {
        this.setState({
          template: props.template,
        });
      }
    }

    return true;
  }

  save = () => {
    this.props.saveTemplate(this.state.template);
    if (this.props.match.params.id != 'new') this.props.getTemplate(this.props.match.params.id);
  }

  scrollToTop = () => window.scrollTo(0, 0);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    console.log(this.props.user);

    let src = '';
    if (this.state.template) src = urls.getBase() + "/images/template/" + this.state.template._id;

    return (
      <div className="content-wrapper pl-4 pr-4">
        <SpinnerView showSpinner={this.props.loading} />
        {this.state.template && <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6 }}>Template Name</label>
          <input type="text" onChange={(e) => this.handleChange('templateName', e.target.value)} value={this.state.template.templateName} style={{ width: '100%', padding: '11px 14px', border: '1px solid rgba(15,31,46,0.12)', borderRadius: 10, fontSize: 14, outline: 'none', background: 'rgba(255,255,255,0.7)' }} />
        </div>}

        {this.state.template && this.state.template.templateEmailBody && <div dangerouslySetInnerHTML={{ __html: this.state.template.templateEmailBody.replace(/(<script)/gi, 'illegalscript') }} ></div>}

        {this.state.template && <div class="form-group green-border-focus">
          <img key={Date.now()} src={`${src}?${new Date().getTime()}`} />
        </div>}

        {this.state.template && <div class="form-group green-border-focus">
          <label for="exampleFormControlTextarea5">Template</label>
          <textarea class="form-control" id="exampleFormControlTextarea5" onChange={(e) => this.handleChange('template', e.target.value)} value={this.state.template.template} rows="3"></textarea>
        </div>}

        {this.state.template && this.state.template.template && <div dangerouslySetInnerHTML={{ __html: this.state.template.template.replace(/(<script)/gi, 'illegalscript') }} ></div>}

        {this.props.user && this.props.user.rank == 'super' && <div>
          <SwitchEditComponent header={'All Companies'} onChangeText={this.handleChange} prop={'anyCompany'} value={this.state.template.anyCompany} />
          <SwitchEditComponent header={'Invoice Template'} onChangeText={this.handleChange} prop={'isInvoice'} value={this.state.template.isInvoice} />
          <SwitchEditComponent header={'Statement Template'} onChangeText={this.handleChange} prop={'isStatement'} value={this.state.template.isStatement} />
          <Select header={'Type'} options={['invoice','statement','custom']} onChangeText={this.handleChange} prop={'type'} value={this.state.template.type} />
        </div>}

        <button type="button" onClick={this.save} style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '10px 20px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 14, cursor: 'pointer', marginRight: 8 }}>Save</button>
        {this.props.user && this.props.user.rank == 'super' && <button type="button" onClick={this.save} style={{ background: 'rgba(13,161,178,0.12)', border: '1px solid rgba(13,161,178,0.25)', color: 'var(--primary-dark)', borderRadius: 10, padding: '10px 20px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 14, cursor: 'pointer' }}>Generate PDF</button>}

      </div>
    );
  }
}

export default HomeView;
